<template>
    <ul id="news_pay_members" class="fee-list">
        <template v-if="userdata && userdata.record.length > 0">
            <template v-for="(item,index) in userdata.record">
                <li  :key="'i' + index">
                    <img  :src="changeUserImgUrls(item.avatar)" />
                </li>
            </template>
        </template>
    </ul>
</template>

<script>
import { changeUserImgUrl } from "../../utils/base"
export default {
    name: "userdata",
    props: ["userdata"],
    methods: {
        changeUserImgUrls (img) {
            return changeUserImgUrl(img)
        }
    }
}
</script>
